<template>
  <div class="history" id="history">
    <!--<video autoplay muted loop id="myVideo">-->
    <!--<source src="/static/images/cover-video-short.mp4" type="video/mp4">-->
    <!--</video>-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-6 history-l">
          <div>
            <h2>Istorija benda</h2>
            <p>Bend je osnovan 2002.god. Osnivaju ga Milos (klavijaturista i pevač) i Andor (gitarista). Sarađivali su dugi niz godina sa poznatim i manje poznatim muzičarima. 2012. godine im se pridružuje Jovana (vokal), potom 2014. Pavle (aranžerista). Ta četvorka je uspešno radila četiri godine, ali su odlučili da prošire bend i tada član grupe postaje i Luka (vokal). Fenix bend je bend za sve vrste proslava. Garantuju odličnu zabavu i provod za pamćenje. Repertoar im je raznolik i zadovoljiće svačiji ukus.</p>
          </div>
        </div>
        <div class="col-6 history-r">
          <div class="swiper-holder" data-aos="fade-left">
            <div class="swiper-nav swiper-nav-left">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </div>
            <div class="swiper-nav swiper-nav-right">
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </div>
            <swiper :options="swiperOption">
              <!-- slides -->
              <swiper-slide>
                <img class="history-image" src="/static/images/slide-image-1.jpg" alt="">
              </swiper-slide>
              <swiper-slide>
                <img class="history-image" src="/static/images/slide-image-2.jpg" alt="">
              </swiper-slide>
              <swiper-slide>
                <img class="history-image" src="/static/images/slide-image-3.jpg" alt="">
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'carrousel',
    data() {
      return {
        swiperOption: {
          loop: true,
          navigation: {
            nextEl: '.swiper-nav-right',
            prevEl: '.swiper-nav-left',
          },
          // autoplay: {
          //   delay: 3000,
          // },
        }
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/HistorySection.vue